import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction:column;
  gap: 0.5rem;
  
  .aside{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background-color: #1d83e2;
    border-radius: 3px;
  }
  .content{
    display: flex;
    height: 100%;
    max-width: 270px;
    flex-direction: column;
    background-color: '';
  }
  .name{
    color: #000000;
  }

  span{
    align-items:center;
    overflow: hidden;
    max-width: 290px;
    color: #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
`
